import * as io from 'io-ts';
import { nullableNumber } from '@shared/core/types/common';

const rootDefinition: io.MixedObject<OLO.Config.HistoryOrdersPage> = {
    ordersLimit: nullableNumber,
};

export const historyOrdersPageSchema = io.type(rootDefinition);
